import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SectionHeader } from "./GameDebugInfoUI";
import { BorderPrimary, GUIHeadlineSuffix, GUISubBox, GUIHeadline } from "../GameUIElements";
import { gameStore } from "../../../../stores/GameStore";
import { useThrottle } from "@react-hook/throttle";
import { autorun } from "mobx";
const ScrollContainer = styled(GUISubBox).withConfig({
  displayName: "SoundSourceDebugUI__ScrollContainer",
  componentId: "sc-za9y7x-0"
})(["display:flex;flex-direction:column;height:100%;overflow-y:scroll;width:100%;"]);
const SectionHeaderLabel = styled.label.withConfig({
  displayName: "SoundSourceDebugUI__SectionHeaderLabel",
  componentId: "sc-za9y7x-1"
})(["display:flex;flex-direction:row;"]);
const SoundSourceContainer = styled.div.withConfig({
  displayName: "SoundSourceDebugUI__SoundSourceContainer",
  componentId: "sc-za9y7x-2"
})(["display:flex;flex-direction:column;margin:2px;padding:2px;", ""], BorderPrimary);
const AdjustedScrollContainer = styled(ScrollContainer).withConfig({
  displayName: "SoundSourceDebugUI__AdjustedScrollContainer",
  componentId: "sc-za9y7x-3"
})(["max-height:245px;"]);
const SoundSourceOverview = observer(({
  soundSources
}) => {
  let playingSoundSources = 0;
  let waitingSoundSources = 0;

  for (const soundSource of soundSources) {
    if (soundSource.debugOutputVolume === null) {
      waitingSoundSources++;
    } else {
      playingSoundSources++;
    }
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, "Playing: ", playingSoundSources), /*#__PURE__*/React.createElement("div", null, "Currently stopped: ", waitingSoundSources), /*#__PURE__*/React.createElement("hr", null));
});
const SoundSourceDisplay = observer(({
  soundSource
}) => {
  return /*#__PURE__*/React.createElement(SoundSourceContainer, null, /*#__PURE__*/React.createElement("div", null, soundSource.soundName, soundSource.debugOutputVolume === null ? /*#__PURE__*/React.createElement("div", null, "Currently stopped") : /*#__PURE__*/React.createElement("progress", {
    value: soundSource.debugOutputVolume,
    max: 1
  })));
});
export const SoundSourceDebugUI = () => {
  const {
    t
  } = useTranslation();

  const getActiveSoundSources = () => Array.from(gameStore.activeSoundSources);

  const [activeSoundSources, setActiveSoundSources] = useThrottle(getActiveSoundSources(), 2);
  useEffect(() => {
    return autorun(() => {
      setActiveSoundSources(getActiveSoundSources());
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(SectionHeaderLabel, null, /*#__PURE__*/React.createElement(GUIHeadline, null, t("game.debug_headline_active_sound_sources"), " "), /*#__PURE__*/React.createElement(GUIHeadlineSuffix, null, "(" + activeSoundSources.length + ")"))), /*#__PURE__*/React.createElement(AdjustedScrollContainer, null, /*#__PURE__*/React.createElement(SoundSourceOverview, {
    soundSources: activeSoundSources
  }), activeSoundSources.map((soundSource, index) => /*#__PURE__*/React.createElement(SoundSourceDisplay, {
    key: index,
    soundSource: soundSource
  }))));
};